import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import {
  DataSourceBinnacle,
  DataSourceBinnacleInitial,
  Note,
} from '@core/interfaces/binnacle';
import { DetailRoutines, Routines, SelectedClient } from '@core/interfaces/selected-client';
import { BinnacleMeetingsService } from '@core/services/binnacle-meetings/binnacle-meetings.service';
import { LocalStorageService } from '@core/services/local-storage.service';
import { SelectedClientService } from '@core/services/selected-client/selected-client.service';
import { catchError, debounceTime, delay, distinctUntilChanged, map, shareReplay, Subject, switchMap, take } from 'rxjs';
import * as moment from 'moment';
import 'moment/locale/es';
import { CustomSnackBarComponent } from '@shared/components/custom-snack-bar/custom-snack-bar.component';
import {
  BinnacleMessageError,
  BinnacleMessageNull,
  BinnacleMessageNullFilters,
} from 'src/assets/data/errors-message';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ManageOrderModalComponent } from '@shared/components/modals/manage-order-modal/manage-order-modal.component';
import { MatSidenav } from '@angular/material/sidenav';
import { DialogCloseSesionComponent } from '@shared/components/modals/dialog-close-sesion/dialog-close-sesion.component';
import { Store } from '@ngrx/store';
import { AppState } from '@core/store/app.reducer';
import * as authActions from '@core/store/auth/auth.actions';
import * as shoppingActions from '@core/store/shoppingCar/shoppingCar.actions';
import * as clientsActions from '@core/store/selectClient/selectClient.actions';
import * as EssentialsActions from '@core/store/essentials/essentials.actions';
import { AuthService } from '@core/services/authentication/auth.service';
import { BinnacleTableComponent } from './binnacle-table/binnacle-table.component';
import { BinnacleModalComponent } from './binnacle-modal/binnacle-modal.component';
@Component({
  selector: 'app-binnacle-meetings-plans',
  templateUrl: './binnacle-meetings-plans.component.html',
  styleUrls: ['./binnacle-meetings-plans.component.scss'],
})
// Añadir estas propiedades en la clase
export class BinnacleMeetingsPlansComponent implements OnInit, OnDestroy {
  currentPage = 1;
  isLoadingMore = false;
  hasMoreData = true;
  totalPages = 1;
  showScrollButton = false;
  // Variables para la gestión de iconos y opciones del componente
  options: any;
  user: Array<any> | any;
  dateClients: Array<SelectedClient> = [];
  isAddingRow = false; // Controla el estado de adición de fila
  isActionRetry = false; // Controla el estado de adición de fila

  // Estado para saber si alguna fila está en modo edición
  isAnyRowEditing = false;
  activeRow: any = null;
  @ViewChild(MatMenuTrigger) myMenu!: MatMenuTrigger;
  @ViewChild('menuTriggerIncompleteForm', { static: true })
  menuTriggerIncompleteForm!: MatMenuTrigger;
  @ViewChild(BinnacleTableComponent) childComponent!: BinnacleTableComponent;
  clientList: any;
  readonly filteredSelect = ['Opción 1', 'Opción 2', 'Opción 3'];
  activeFilters: any = {
    status: [],
    visibility: [],
    customers: [],
    startDate: '',
    endDate: ''
  };

  loadingSkeleton = true;
  booleanMessageError = false;
  listResponseNull: any;
  selectedClient: any;
  selectedClientCode: any = ''; // Aquí se almacena el código del cliente seleccionado
  readonly horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  readonly verticalPosition: MatSnackBarVerticalPosition = 'bottom';
  // DataSource con datos de ejemplo
  dataSourceBinnacleList: DataSourceBinnacle[] = []; // Propiedad para almacenar los datos transformados
  dataSourceBinnacleListInitial!: DataSourceBinnacleInitial | null; // Propiedad para almacenar los datos transformados

  isDataLoading: boolean = true; // Estado de carga de datos
  readonly binnacleMessageNull = [BinnacleMessageNull];
  readonly binnacleMessageNullFilters = [BinnacleMessageNullFilters];
  readonly binnacleMessageError = [BinnacleMessageError];
  isServiceError: boolean = false; // Bandera para indicar error en el servicio
  isLoadingRegistrationService: boolean = false;
  isErrorRegistrationService: boolean = false;
  successButton: string = 'Guardar registro';
  private retryCount = 0; // Contador para rastrear intentos
  private readonly maxRetries = 4; //
  private pendingToggles: any;

  // Columnas que se mostrarán en la tabla
  readonly displayedColumns: string[] = [
    'Visibilidad cliente',
    'Cliente',
    'Fecha de ejecución Inicio - Fin',
    'Estado',
    'Rutina',
    'Categoría',
    'Acuerdos/Pendientes',
    'Responsable',
    'Área soporte',
    'Fecha de creación',
    'Notas del vendedor',
    'Notas del cliente',
    'acciones',
  ];

  rowErrors: { [key: string]: { [field: string]: boolean } } = {}; // Mapa de errores por fila
  @ViewChild('drawerProfileOptions')
  sidenavProfile!: MatSidenav;
  routinesList: DetailRoutines[] = [];
  routinesListLoading: boolean = false;
  routinesMessageError: boolean = false;
  selectRoutines?: DetailRoutines;
  searchText: string = ''; // texto del buscador
  private readonly dataRequest$ = new Subject<{ pageNumber: number; filters: any }>();
  @ViewChild('tableContainer') tableContainer!: ElementRef;
  constructor(
    private readonly _localStorageService: LocalStorageService,
    private readonly _selectedClientService: SelectedClientService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly _binnacleMeetingsService: BinnacleMeetingsService,
    private readonly _snackBar: MatSnackBar,
    private readonly dialog: MatDialog,
    public readonly dialogCloseSesion: MatDialog,
    private readonly store: Store<AppState>,
    private readonly _authService: AuthService
  ) {
    // Registro de iconos SVG
  }

  ngOnInit() {
    this.initDataSelectclient();
    this.initDataRoutines();
    this.currentPage = 1;

    const storedFilters = localStorage.getItem('binnacleFilters');
    this.activeFilters = storedFilters
      ? this.removeAllFromFilters(JSON.parse(storedFilters))
      : {
        status: [],
        visibility: [],
        customers: [],
        startDate: '',
        endDate: '',
      };

    // 🔹 Configuramos el flujo reactivo UNA sola vez
    this.dataRequest$
      .pipe(
        switchMap(({ pageNumber, filters }) => {
          if (pageNumber === 1) {
            this.isDataLoading = true;
            this.dataSourceBinnacleList = [];
          }

          const dataBody = {
            sellerEmail: this.user.email,
            pageNumber,
            searchText: this.searchText || '',
            filters: {
              status: filters?.status || [],
              visibility: filters?.visibility || [],
              customers: filters?.customers || [],
              startDate: filters?.startDate
                ? moment(filters?.startDate).format('YYYY-MM-DD')
                : '',
              endDate: filters?.endDate
                ? moment(filters?.endDate).format('YYYY-MM-DD')
                : '',
            },
          };

          // 🔹 Si llega una nueva emisión, esta petición se CANCELA automáticamente
          return this._binnacleMeetingsService.getBinnacleListGeneral(dataBody).pipe(delay(2000), // simula un retraso de red de 2 segundos
            catchError((err) => {
              this.isDataLoading = false;
              this.isServiceError = true;
              throw err;
            })
          );
        })
      )
      .subscribe({
        next: (data) => {
          this.isDataLoading = false;
          this.isServiceError = false;
          this.isLoadingMore = false;

          if (data) {
            const transformedData = this.transformBinnacleData(data);
            this.totalPages = data.totalPages || 1;
            this.currentPage = data.currentPage || 1;
            this.dataSourceBinnacleList =
              this.currentPage === 1
                ? transformedData
                : [...this.dataSourceBinnacleList, ...transformedData];
            this.hasMoreData = this.currentPage < this.totalPages;
          } else {
            this.dataSourceBinnacleList = [];
            this.hasMoreData = false;
          }
        },
      });

    // 🔹 Emitimos la PRIMERA carga de datos
    this.getBinnacleDataList(this.currentPage, this.activeFilters);
  }

  ngAfterViewInit() {
    const container = this.tableContainer?.nativeElement;
    if (!container) return;

    setTimeout(() => {
      const needsSpace = container.scrollHeight <= container.clientHeight;
      const spacerId = 'forced-scroll-spacer';
      const existingSpacer = container.querySelector(`#${spacerId}`);

      // 🔹 Agrega espaciador solo si no hay suficiente contenido
      if (needsSpace && !existingSpacer) {
        const spacer = document.createElement('div');
        spacer.id = spacerId;
        spacer.style.height = '200px';
        spacer.style.pointerEvents = 'none';
        container.appendChild(spacer);
      }

      // 🔹 Si ya hay suficiente contenido, lo quita
      if (!needsSpace && existingSpacer) {
        existingSpacer.remove();
      }
    }, 300);
  }
  private removeAllFromFilters(filters: any) {
    return {
      status: (filters.status || []).filter((s: any) => {
        if (typeof s === 'object') return s.value !== 'all';
        return s !== 'all';
      }),
      visibility: (filters.visibility || []).filter((v: any) => {
        if (typeof v === 'object') return v.value !== 'all';
        return v !== 'all';
      }),
      customers: (filters.customers || []).filter((c: any) => {
        if (typeof c === 'object') return c.code !== 'all';
        return c !== 'all';
      }),
      startDate: filters.startDate,
      endDate: filters.endDate,
    };
  }
  initDataSelectclient() {
    this.loadingSkeleton = true;
    this.user = this._localStorageService.getItem('user');
    this._selectedClientService
      .getSelectClient(this.user?.code)
      .pipe(take(1))
      .subscribe(
        (res: any) => {
          this.loadingSkeleton = false;
          this.booleanMessageError = false;
          this.listResponseNull = res;
          if (this.listResponseNull) {

            this.dateClients = res.map((element: any) => {
              const phoneNumber = element.phone ? element.phone : '_';
              const countryCode = phoneNumber?.slice(0, 3);
              const firstGroup = phoneNumber?.slice(3, 6);
              const secondGroup = phoneNumber?.slice(6, 9);
              const thirdGroup = phoneNumber?.slice(9);

              const separatedPhoneNumber = `${countryCode} ${firstGroup} ${secondGroup} ${thirdGroup}`;
              let temp: any = {
                ...element,
                isSelected: false,
                phone: separatedPhoneNumber,
              };
              return temp;
            });
            this.selectedClient = this.dateClients[0];
            this.selectedClientCode = this.selectedClient?.code;
          }
        },
        (error: any) => {
          this.booleanMessageError = true;
          this.loadingSkeleton = false;
        }
      );
  }
  initDataRoutines() {
    this.routinesList = [];
    this.routinesListLoading = true;
    this.routinesMessageError = false;

    this._selectedClientService
      .getRoutinesList(this.user?.code)
      .pipe(take(1))
      .subscribe(
        (res: Routines) => {
          // Asegúrate de que 'res.routines' sea un array de 'DetailRoutines'
          this.routinesList = res?.routines || []; // Asignamos un array vacío si no existe 'routines'

          // Si es necesario, asigna selectRoutines como el primer item del array
          if (this.routinesList.length > 0) {
            this.selectRoutines = this.routinesList[0];
          }

          localStorage.setItem('lastFetchDate', new Date().toDateString());
          this.routinesListLoading = false;
        },
        () => {
          this.routinesListLoading = false;
          this.routinesMessageError = true;
        }
      );
  }

  getBinnacleDataList(pageNumber, filters) {
    if (pageNumber === 1) {
      this.isDataLoading = true;
      this.dataSourceBinnacleList = [];
    }

    const dataBody = {
      sellerEmail: this.user.email,
      pageNumber: pageNumber,
      searchText: this.searchText || '', // puedes luego reemplazar por this.searchText si lo conectas a un input
      filters: {
        status: filters?.status || [],
        visibility: filters?.visibility || [],
        customers: filters?.customers || [],
        startDate: (filters?.startDate) ? moment(filters?.startDate).format(
          'YYYY-MM-DD') : '',
        endDate: (filters?.endDate) ? (moment(filters?.endDate).format(
          'YYYY-MM-DD')) : ''
      }
    };

    this._binnacleMeetingsService
      .getBinnacleListGeneral(dataBody)
      .pipe(take(1),
        debounceTime(300),
        distinctUntilChanged(),)
      .subscribe({
        next: (data) => {
          this.isDataLoading = false;
          this.isServiceError = false;
          this.isLoadingMore = false;

          if (data) {
            // 🔹 Guardamos toda la respuesta para otros usos
            this.dataSourceBinnacleListInitial = data;

            // 🔹 Transformamos los registros para mostrar en tabla
            const transformedData = this.transformBinnacleData(data);
            // 🔹 Guardamos info de paginación desde el backend
            this.totalPages = data.totalPages || 1;
            this.currentPage = data.currentPage || 1;

            if (pageNumber === 1) {
              // Primera carga (últimos 6 meses)
              this.dataSourceBinnacleList = transformedData;
            } else {
              // Agregar más meses al hacer scroll
              this.dataSourceBinnacleList = [
                ...this.dataSourceBinnacleList,
                ...transformedData,
              ];
            }

            // 🔹 Verificar si quedan más páginas por cargar
            this.hasMoreData = this.currentPage < this.totalPages;
          } else {
            // 🔹 Caso: backend no trae datos
            if (pageNumber === 1) {
              this.dataSourceBinnacleList = [];
              this.dataSourceBinnacleListInitial = null;
            }
            this.hasMoreData = false;
          }
        },
        error: (err) => {
          this.isDataLoading = false;
          this.isServiceError = true;
          this.isLoadingMore = false;
        },

      }), shareReplay(1);

  }

  scrollToTop(): void {
    const element = document.querySelector('.container-body');
    if (element) {
      element.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  onTableScroll(event: any): void {
    const element = document.querySelector('.container-body'); // contenedor con scroll
    if (!element) return;

    const scrollTop = element.scrollTop;
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;

    // 🔹 Mostrar botón "Subir" si scrolleaste más de 300px
    this.showScrollButton = scrollTop > 300;

    // 🔹 Scroll infinito
    const threshold = 50; // margen de 50px antes del final
    const reachedBottom = scrollTop + clientHeight >= scrollHeight - threshold;

    if (
      reachedBottom &&
      !this.isLoadingMore &&
      this.hasMoreData &&
      !this.isAddingRow &&
      !this.isRowBeingEdited()
    ) {
      this.isLoadingMore = true;
      this.currentPage++;
      this.getBinnacleDataList(this.currentPage, this.activeFilters);
    }
  }
  transformBinnacleData(serviceData: any): DataSourceBinnacle[] {
    return serviceData?.binnacles?.map((binnacle: any) => ({
      'Visibilidad cliente': binnacle.isVisible,
      // Lógica de asignación para 'Cliente' y 'ClienteOTRO'
      Cliente: binnacle.type === 'otros' ? 'otros' : binnacle.customerCode,  // Si 'type' es 'otros', Cliente será 'otros', si no, tomará el customerCode
      ClienteOTRO: binnacle.type === 'otros' ? binnacle.customerCode : null, // Si 'type' es 'otros', asignamos customerCode, si no, ponemos null
      type: binnacle.type,
      'Fecha de ejecución Inicio - Fin': (binnacle.startDate && binnacle.endDate)
        ? {
          start: new Date(`${binnacle.startDate}T23:59:59Z`),
          end: new Date(`${binnacle.endDate}T23:59:59Z`),
        }
        : { start: null, end: null },


      Estado: binnacle.status,
      Rutina: binnacle?.routineId,
      RutinaName: binnacle.routineName,
      Categoría: binnacle.category,
      'Acuerdos/Pendientes': binnacle.activities,
      Responsable: binnacle.responsible,
      'Área soporte': binnacle.supportArea,
      'Fecha de creación': new Date(binnacle.createdAt)
        .toISOString()
        .split('T')[0],
      'Notas del vendedor': binnacle.notes
        ?.filter((note: Note) => note.type === 'S')
        .map((note: Note) => ({
          id: note.id,
          type: note.type,
          note: note.note,
          createdAt: moment(note.createdAt).format('DD/MM/YYYY'),
          updatedAt: note.updatedAt,
        })),
      'Notas del cliente': binnacle.notes
        ?.filter((note: Note) => note.type === 'C')
        .map((note: Note) => ({
          id: note.id,
          type: note.type,
          note: note.note,
          createdAt: moment(note.createdAt).format('DD/MM/YYYY'),
          updatedAt: note.updatedAt,
        })),
      isExecutionDateEditable: binnacle.isExecutionDateEditable,
      isEditing: false,
      isNewRegister: false,
      nameClient: binnacle.customerName,
      idBinnacle: binnacle.id,
    }));
  }
  addNewRow() {
    this.successButton = 'Guardar registro';
    if (this.isAddingRow) return;
    this.retryCount = 0;
    this.isErrorRegistrationService = false;
    const newRow: DataSourceBinnacle = {
      'Visibilidad cliente': false,
      Cliente: '',
      type: '',
      routineId: "",
      'Fecha de ejecución Inicio - Fin': { start: null, end: null },
      Estado: 'Por iniciar',
      Rutina: '',
      Categoría: '',
      'Acuerdos/Pendientes': '',
      Responsable: '',
      'Área soporte': '',
      'Fecha de creación': '',
      'Notas del vendedor': [],
      'Notas del cliente': [],
      isEditing: false,
      isNewRegister: true,
    };

    this.dataSourceBinnacleList = [newRow, ...this.dataSourceBinnacleList];
    this.isAddingRow = true;
    this.isActionRetry = true;
    this.cdRef.detectChanges();
  }
  updatingValues(value: any) {
    // Encontrar el índice del último registro (nuevo) usando isNewRegister
    const index = this.dataSourceBinnacleList.findIndex(
      (row) => row.isNewRegister
    );
    if (index !== -1) {
      // Si es necesario, puedes validar nuevamente los campos después de la actualización
      const errors = this.validateRow(
        this.dataSourceBinnacleList[index],
        index,
        value.nameInput
      );
    }
  }

  saveRow(event: MouseEvent, menu: MatMenuTrigger) {
    const lastRow = this.dataSourceBinnacleList.find(
      (row) => row.isNewRegister === true
    );
    if (!lastRow) {
      return;
    }
    if (this.pendingToggles) {
      lastRow['Visibilidad cliente'] = this.pendingToggles.newState;
    }
    const rowId = this.dataSourceBinnacleList.indexOf(lastRow);

    const errors = this.validateRow(lastRow, rowId, 'Todas');
    if (
      Object.keys(errors).length > 0 &&
      Object.keys(errors).some((key) => Object.keys(errors[key]).length > 0)
    ) {
      return; // Salir si hay errores
    } else {
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
        event.stopPropagation();
      }
      if (this.menuTriggerIncompleteForm) {
        this.menuTriggerIncompleteForm.closeMenu();
      }
      if (menu && menu.menuOpen) {
        menu.closeMenu();
      }
    }
    this.isLoadingRegistrationService = true;
    this.isErrorRegistrationService = false;
    this.isAddingRow = false;
    const dataBodyRegitered = {
      customerCode: (lastRow['Cliente'] == 'otros' && lastRow['ClienteOTRO']) ? `${lastRow['ClienteOTRO']}` : lastRow['Cliente'],
      type: lastRow['type'],
      routineId: lastRow['Rutina'],
      startDate: moment(
        lastRow['Fecha de ejecución Inicio - Fin']?.start
      ).isValid()
        ? moment(lastRow['Fecha de ejecución Inicio - Fin']?.start).format(
          'YYYY-MM-DD'
        )
        : '',
      endDate: moment(lastRow['Fecha de ejecución Inicio - Fin']?.end).isValid()
        ? moment(lastRow['Fecha de ejecución Inicio - Fin']?.end).format(
          'YYYY-MM-DD'
        )
        : '',
      status: lastRow['Estado'] || 'Por iniciar',
      category: lastRow['Categoría'] || '',
      activities: lastRow['Acuerdos/Pendientes'] || '',
      responsible: lastRow['Responsable'] || '',
      supportArea: lastRow['Área soporte'] || '',
      isVisible: lastRow['Visibilidad cliente'] || false,
      notes: (this.getReversedItems(lastRow['Notas del vendedor']) || []).concat(
        this.getReversedItems(lastRow['Notas del cliente']) || []
      ),
      sellerEmail: this.user.email
    };
    this._binnacleMeetingsService
      .getBinnacleSave(dataBodyRegitered)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.retryCount = 0; // Reinicia el contador en caso de éxito
          lastRow.isNewRegister = false;
          lastRow.isEditing = false;
          this.isLoadingRegistrationService = false;

          this.showSnackBar(
            'Se agregó un nuevo registro correctamente.', // Mensaje del éxito
            'Entendido', // Texto del botón
            ['custom-snack-bar-check', 'binnacle-snack-bar']
          );
          this.currentPage = 1;
          this.getBinnacleDataList(1, this.activeFilters);
          this.isActionRetry = false; // Desactiva el intento de agregar fila
          this.pendingToggles=null;
          this.cancelAddRow(false);
        },
        error: () => {
          this.retryCount++; // Incrementa el contador de intentos
          this.isLoadingRegistrationService = false;
          this.isErrorRegistrationService = true;

          if (this.retryCount < this.maxRetries) {
            // Mostrar mensaje de reintento
            this.showSnackBar(
              'No pudimos guardar tu nuevo registro.', // Mensaje del error
              'Reintentar', // Texto del botón
              'custom-snack-bar-error', // Clase personalizada
              () => this.saveRow(event, menu) // Acción de reintento
            );
          } else {
            // Mostrar mensaje final tras superar intentos máximos
            this.showSnackBar(
              'Lo sentimos no pudimos guardar tu registro, vuelve a intentarlo en unos minutos.', // Mensaje del error final
              'Entendido', // Texto del botón
              'custom-snack-bar-error-end'
            );
            this.retryCount = 0; // Reinicia el contador
            this.isActionRetry = false; // Desactiva la acción de reintento
            this.cancelAddRow(false); // Cancela la adición de fila
          }
        },
      });
  }

  // Función para activar o desactivar el modo edición en una fila
  editRow(element: any) {
    this.successButton = 'Guardar cambios';
    // Si ya hay una fila activa (en edición), desactivar la edición
    if (this.activeRow && !this.activeRow.isNewRegister) {
      this.dataSourceBinnacleList.forEach((row) => {
        if (row !== element) {
          row.isEditing = false; // Desactivar la edición de otras filas
          row.isNewRegister = false; // Desactivar el nuevo registro en otras filas
        }
      });
    }

    // Si la fila ya está en edición, desactivarla
    if (this.activeRow === element) {
      element.isEditing = !element.isEditing;
      this.activeRow = null; // Limpiar la fila activa
    } else {
      // Si no había una fila activa, activar la edición de la fila seleccionada
      if (this.activeRow) {
        this.activeRow.isEditing = false; // Desactivar la fila previamente activa
      }
      element.isEditing = true; // Activar la fila seleccionada
      this.activeRow = element; // Establecer la fila activa
    }
  }

  getReversedItems(list: any[]): any[] {
    return list ? [...list].reverse() : [];
  }

  editSaveRow(event: MouseEvent, menu: MatMenuTrigger) {
    const lastRow = this.dataSourceBinnacleList.find(
      (row) => row.isEditing === true
    );
    if (!lastRow) {
      return;
    }
    if (this.pendingToggles) {
      lastRow['Visibilidad cliente'] = this.pendingToggles.newState;
    }
    const rowId = this.dataSourceBinnacleList.indexOf(lastRow);
    const errors = this.validateRow(lastRow, rowId, 'Todas');
    if (
      Object.keys(errors).length > 0 &&
      Object.keys(errors).some((key) => Object.keys(errors[key]).length > 0)
    ) {
      return; // Salir si hay errores
    } else {
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
        event.stopPropagation();
      }
      if (this.menuTriggerIncompleteForm) {
        this.menuTriggerIncompleteForm.closeMenu();
      }
      if (menu && menu.menuOpen) {
        menu.closeMenu();
      }
      this.isLoadingRegistrationService = true;
      this.isErrorRegistrationService = false;

      let body = {
        id: lastRow.idBinnacle,
        routineId: lastRow['Rutina'],
        startDate: moment(
          lastRow['Fecha de ejecución Inicio - Fin']?.start
        ).isValid()
          ? moment(lastRow['Fecha de ejecución Inicio - Fin']?.start).format(
            'YYYY-MM-DD'
          )
          : '',
        endDate: moment(
          lastRow['Fecha de ejecución Inicio - Fin']?.end
        ).isValid()
          ? moment(lastRow['Fecha de ejecución Inicio - Fin']?.end).format(
            'YYYY-MM-DD'
          )
          : '',
        status: lastRow['Estado'],
         category: lastRow['Categoría'],
      activities: lastRow['Acuerdos/Pendientes'] ,
        responsible: lastRow['Responsable'],
        supportArea: lastRow['Área soporte'],
        isVisible: lastRow['Visibilidad cliente'],
        // Filtrar las notas eliminadas (de tipo NoteDelete)
        deleteNotes: lastRow['Notas del vendedor']
          .filter((note: any) => note?.isDelete === true) // Filtramos las notas con isDelete
          .map((note: any) => ({
            id: note.id, // Solo tomamos el id de la nota eliminada
          })),

        // Filtrar las notas nuevas (de tipo Note)
        saveNotes: this.getReversedItems(lastRow['Notas del vendedor'])
          .filter((note: Note) => note?.isNew === true) // Filtramos las notas con isNew
          .map((note: Note) => ({
            type: 'S', // El tipo de la nota
            note: note.note, // El texto de la nota
          })),
      };
      // Set array vacio cuando una nota se abre y se cierra en la misma interacción
      if (
        body.deleteNotes.length === 1 &&
        Object.values(body.deleteNotes[0]).every((value) => value === undefined)
      ) {
        body.deleteNotes = [];
      }
      this._binnacleMeetingsService
        .getBinnacleEdit(body)
        .pipe(take(1))
        .subscribe({
          next: () => {
            this.isLoadingRegistrationService = false;
            this.showSnackBar(
              'Se guardaron tus cambios correctamente.', // Mensaje del éxito
              'Entendido', // Texto del botón
              ['custom-snack-bar-check', 'binnacle-snack-bar']
            );
            this.currentPage = 1;
            this.getBinnacleDataList(1, this.activeFilters);
            this.isActionRetry = false; // Desactiva el intento de agregar fila

            this.cancelAddRow(false);
          },
          error: () => {
            this.retryCount++; // Incrementa el contador de intentos
            this.isLoadingRegistrationService = false; // Detén el indicador de carga
            this.isErrorRegistrationService = true; // Activa la bandera de error

            if (this.retryCount < this.maxRetries) {
              // Mostrar mensaje de reintento
              this.showSnackBar(
                'No pudimos guardar tus cambios.', // Mensaje del error
                'Reintentar', // Texto del botón
                'custom-snack-bar-error', // Clase personalizada
                () => this.editSaveRow(event, menu) // Acción de reintento
              );
            } else {
              // Mostrar mensaje final tras superar intentos máximos
              this.showSnackBar(
                'Lo sentimos no pudimos guardar tus cambios, vuelve a intentarlo en unos minutos.', // Mensaje del error final
                'Entendido', // Texto del botón
                'custom-snack-bar-error-end'
              );
              this.retryCount = 0; // Reinicia el contador
              this.isActionRetry = false; // Desactiva la acción de reintento
              this.cancelEditRow(false); // Cancela la edición
            }
          },
        });
    }
  }
  // Función para verificar si el botón de editar debe estar deshabilitado
  isEditDisabled(element: any): boolean {
    // Deshabilitar si la fila está en edición o si es un nuevo registro
    return (
      (this.activeRow && this.activeRow !== element) || element.isNewRegister
    );
  }
  validateRow(
    lastRow: any,
    rowId: number,
    nameInput: string
  ): { [field: string]: boolean } {
    var localErrors: any; // Correción, declaramos un objeto

    localErrors = { ...this.rowErrors };

    // Si nameInput es 'Todas', validar todos los campos
    if (nameInput === 'Todas') {
      localErrors[rowId] = {};

      // Validar Cliente
      if (!lastRow['Cliente']) {
        localErrors[rowId]['Cliente'] = true;
      } else {
        delete localErrors[rowId]['Cliente']; // Eliminar error si el campo es corregido
      }

      // Validar fechas de ejecución
      // const datesError = this.validateDates(lastRow);
      // if (datesError) {
      //   localErrors[rowId]['Fecha de ejecución Inicio - Fin'] = true;
      // } else {
      //   delete localErrors[rowId]['Fecha de ejecución Inicio - Fin'];
      // }

      // Validar Rutina
      // if (!lastRow['Rutina']) {
      //   localErrors[rowId]['Rutina'] = true;
      // } else {
      //   delete localErrors[rowId]['Rutina']; // Eliminar error si el campo es corregido
      // }

      // Validar Categoría
      // const categoria = lastRow['Categoría']?.trim();
      // if (!categoria || categoria.length < 1 || categoria.length > 1000) {
      //   localErrors[rowId]['Categoría'] = true;
      // } else {
      //   delete localErrors[rowId]['Categoría']; // Eliminar error si el campo es corregido
      // }

      // Validar Planes
      const planesAct = lastRow['Acuerdos/Pendientes']?.trim();
      if (!planesAct || planesAct.length < 3 || planesAct.length > 1000) {
        localErrors[rowId]['Acuerdos/Pendientes'] = true;
      } else {
        delete localErrors[rowId]['Acuerdos/Pendientes']; // Eliminar error si el campo es corregido
      }

      // Validar Responsable
      // const responsable = lastRow['Responsable']?.trim();
      // if (!responsable || responsable.length < 1 || responsable.length > 1000) {
      //   localErrors[rowId]['Responsable'] = true;
      // } else {
      //   delete localErrors[rowId]['Responsable']; // Eliminar error si el campo es corregido
      // }

      // Validar Área soporte
      // const area = lastRow['Área soporte']?.trim();
      // if (!area || area.length < 1 || area.length > 1000) {
      //   localErrors[rowId]['Área soporte'] = true;
      // } else {
      //   delete localErrors[rowId]['Área soporte']; // Eliminar error si el campo es corregido
      // }

      this.rowErrors = { ...localErrors };
    } else {
      // Si rowId ya tiene errores registrados en localErrors
      if (rowId in localErrors) {
        // Validar el campo específico que se pasa
        localErrors = this.validateField(
          lastRow,
          rowId,
          nameInput,
          localErrors[rowId]
        );

        // Si no hay errores en este campo, eliminamos del objeto
        if (!localErrors[nameInput]) {
          delete localErrors[nameInput];
        }

        // Actualizar directamente los errores del rowId
        this.rowErrors[rowId] = { ...localErrors };
      } else {
        // Si no hay errores previos, inicializar con una validación
        localErrors[rowId] = this.validateField(lastRow, rowId, nameInput, {});

        // Si no se detectan errores después de validar, limpiar
        if (Object.keys(localErrors[rowId]).length === 0) {
          delete localErrors[rowId];
        } else {
          this.rowErrors[rowId] = { ...localErrors[rowId] };
        }
      }
    }
    return localErrors;
  }

  validateField(
    lastRow: any,
    rowId: number,
    nameInput: string,
    errors: { [field: string]: boolean }
  ) {
    switch (nameInput) {
      case 'Cliente':
        if (!lastRow['Cliente']) {
          errors['Cliente'] = true;
        } else {
          errors['Cliente'] = false;
        }
        break;
      case 'Fecha de ejecución Inicio - Fin':
        const datesError = this.validateDates(lastRow);
        if (datesError) {
          errors['Fecha de ejecución Inicio - Fin'] = true;
        } else {
          errors['Fecha de ejecución Inicio - Fin'] = false;
        }
        break;
      case 'Rutina':
        if (!lastRow['Rutina']) {
          errors['Rutina'] = true;
        } else {
          errors['Rutina'] = false;
        }
        break;
      case 'Categoría':
        const categoria = lastRow['Categoría']?.trim();
        if (!categoria || categoria.length < 1 || categoria.length > 1000) {
          errors['Categoría'] = true;
        } else {
          errors['Categoría'] = false;
        }
        break;
      case 'Acuerdos/Pendientes':
        const planesAct = lastRow['Acuerdos/Pendientes']?.trim();
        if (!planesAct || planesAct.length < 3 || planesAct.length > 1000) {
          errors['Acuerdos/Pendientes'] = true;
        } else {
          errors['Acuerdos/Pendientes'] = false;
        }
        break;
      case 'Responsable':
        const responsable = lastRow['Responsable']?.trim();
        if (
          !responsable ||
          responsable.length < 1 ||
          responsable.length > 1000
        ) {
          errors['Responsable'] = true;
        } else {
          errors['Responsable'] = false;
        }
        break;
      case 'Área soporte':
        const area = lastRow['Área soporte']?.trim();
        if (!area || area.length < 1 || area.length > 1000) {
          errors['Área soporte'] = true;
        } else {
          errors['Área soporte'] = false;
        }
        break;
    }

    return errors;
  }

  validateDates(element: any): boolean {
    const startDate = element['Fecha de ejecución Inicio - Fin'].start
      ? new Date(element['Fecha de ejecución Inicio - Fin'].start)
      : null;
    const endDate = element['Fecha de ejecución Inicio - Fin'].end
      ? new Date(element['Fecha de ejecución Inicio - Fin'].end)
      : null;

    // Si alguna de las fechas es null o inválida
    if (
      !startDate ||
      !endDate ||
      Number.isNaN(startDate.getTime()) ||
      Number.isNaN(endDate.getTime())
    ) {
      return true; // Indicar que hay un error
    }

    // Validar si la fecha inicial es mayor que la fecha final
    if (startDate > endDate) {
      return true; // Indicar que hay un error
    }

    return false; // No hay error
  }


  // Función para cancelar la edición de una fila
  cancelEdit() {
    if (this.activeRow) {
      this.activeRow.isEditing = false; // Desactivamos el modo edición
      this.activeRow = null; // Reseteamos la fila activa
    }
  }

  cancelAddRow(value) {
    if (value) {
      // Si el valor es verdadero, se abre el modal y se espera la respuesta
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = false;
      dialogConfig.data = { status: 3 }; // Pasar los datos que necesites
      dialogConfig.width = '31rem';

      this.dialog
        .open(ManageOrderModalComponent, dialogConfig)
        .afterClosed()
        .pipe(
          map((result) => result === true) // Compara si la respuesta del modal es true
        )
        .subscribe((shouldDelete) => {
          if (shouldDelete) {
            // Si el modal devuelve `true`, eliminar la fila
            this.deleteRow();
          }
        });
    } else {
      this.deleteRow();
    }
  }

  cancelEditRow(value): void {
    if (value) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = false;
      dialogConfig.data = { status: 4 }; // Pasar datos necesarios para el modal
      dialogConfig.width = '31rem';
      this.dialog
        .open(ManageOrderModalComponent, dialogConfig)
        .afterClosed()
        .pipe(
          map((result) => result === true) // Verificar si el resultado del modal es verdadero
        )
        .subscribe((shouldCancel) => {
          if (shouldCancel) {
            // Desactivar la edición sin eliminar la fila
            this.dataSourceBinnacleList?.forEach((item) => {
              if (item?.isEditing) {
                item.isEditing = false; // Desactiva el modo edición
              }
            });
            this.dataSourceBinnacleList = JSON.parse(
              JSON.stringify(this.childComponent.tempData)
            );
            this.pendingToggles?.clear();
            // Limpiar las referencias y estados
            this.activeRow = null;
            this.isAnyRowEditing = false;
            this.rowErrors = {};
            // Forzar la detección de cambios
            this.cdRef.detectChanges();
          }
        });
    } else {
      this.isErrorRegistrationService = false;
      // Desactivar la edición sin eliminar la fila
      this.dataSourceBinnacleList.forEach((item) => {
        if (item.isEditing) {
          item.isEditing = false; // Desactiva el modo edición
        }
      });
      this.dataSourceBinnacleList = JSON.parse(
        JSON.stringify(this.childComponent.tempData)
      );
      this.pendingToggles.clear();
      // Limpiar las referencias y estados
      this.activeRow = null;
      this.isAnyRowEditing = false;

      // Forzar la detección de cambios
      this.cdRef.detectChanges();
    }
  }

  deleteRow() {
    // Verifica si hay una fila en estado de adición
    if (this.isAddingRow || !this.isActionRetry || this.isRowBeingEdited()) {
      // Filtra la lista para eliminar cualquier fila nueva (`isNewRegister`)
      this.dataSourceBinnacleList = this.dataSourceBinnacleList.filter(
        (item) => !item.isNewRegister
      );

      // Resetea los estados de adición y la fila activa
      this.isAddingRow = false;
      this.isActionRetry = false;
      this.activeRow = null;
      this.rowErrors = {};
      // Forzar la detección de cambios para asegurar la sincronización
      this.cdRef.detectChanges();
    }
  }

  onFocus(textarea: HTMLTextAreaElement) {
    if (textarea) {
      textarea.style.height = 'auto'; // Reseteamos la altura
      textarea.style.height = `${textarea.scrollHeight}px`; // Ajustamos la altura al contenido
    }
  }

  onBlur(textarea: HTMLTextAreaElement) {
    if (textarea) {
      textarea.style.height = '40px'; // Restablecemos la altura mínima
    }
  }

  autoGrow(event: any) {
    const textarea = event.target;
    if (textarea) {
      textarea.style.height = 'auto'; // Reseteamos la altura
      textarea.style.height = `${textarea.scrollHeight}px`; // Ajustamos la altura según el contenido
    }
  }

  // Función para restablecer la altura del textarea
  resetTextareaHeight(textarea: HTMLTextAreaElement) {
    textarea.style.height = '40px'; // Restablece la altura mínima
  }

  // Función para abrir el perfil del usuario (vacía por ahora)
  openProfile() {
    this.sidenavProfile.toggle();
  }

  // Función para cerrar el perfil del usuario (vacía por ahora)
  closeProfile(event: string) {
    this.sidenavProfile.close();
    if (event === 'logout') {
      setTimeout(() => {
        this.openModalCloseSesion();
      }, 350);
    }
  }
  openModalCloseSesion() {
    const dialogRef = this.dialogCloseSesion.open(DialogCloseSesionComponent, {
      width: '31rem',
      data: {},
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data?.status) {
        this.store.dispatch(authActions.unsetUser());
        this.store.dispatch(shoppingActions.unsetCar());
        this.store.dispatch(clientsActions.unsetClients());
        this.store.dispatch(EssentialsActions.clearAll());
        this._authService.logout();
      }
    });
  }

  handleToggleConfirmed(data: any) {
    this.pendingToggles = data; // Guardar el elemento con cambio pendiente
  }

  // Función para abrir y cerrar el panel de selección (vacía por ahora)
  clientSelect() {
    this.myMenu.closeMenu();
  }
  // Método para verificar si existe una fila en edición
  isRowBeingEdited(): boolean {
    return this.dataSourceBinnacleList.some((row) => row.isEditing);
  }
  filterOpenModal() {
    const isMobile = window.innerWidth <= 767;
    const dialogRef = this.dialog.open(BinnacleModalComponent, {
      width: isMobile ? '23.4rem' : '26.7rem',
      height: isMobile ? '96vh' : '85vh',
      maxWidth: isMobile ? '96vw' : '95vw',
      panelClass: ['custom-dialog-padding', 'binnacle-dialog-right'],
      data: this.dateClients

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.activeFilters = result; // <--- guardamos los filtros actuales
        this.getBinnacleDataList(1, result);

      }
    });
  }

  onSearch() {
    this.currentPage = 1;

    const activeFilters = this.activeFilters || {
      status: [],
      visibility: [],
      customers: [],
      startDate: '',
      endDate: ''
    };

    const length = this.searchText?.trim().length || 0;

    // 🔹 Caso 1: tiene 3 o más caracteres → buscar
    if (length >= 3) {
      this.dataRequest$.next({ pageNumber: this.currentPage, filters: activeFilters });
    }
    // 🔹 Caso 2: tiene menos de 3 → restaurar lista original
    else {
      // solo si antes ya habíamos hecho una búsqueda
      if (this.dataSourceBinnacleList.length !== this.dataSourceBinnacleListInitial?.binnacles?.length) {
        this.searchText = ''; // opcional, limpiar input
        this.dataRequest$.next({ pageNumber: 1, filters: activeFilters });
      }
    }
  }


  clearSearch() {
    this.searchText = '';
    this.currentPage = 1;

    const activeFilters = this.activeFilters || {
      status: [],
      visibility: [],
      customers: [],
      startDate: '',
      endDate: ''
    };

    this.dataRequest$.next({ pageNumber: this.currentPage, filters: activeFilters });
  }
  getActiveFiltersCount(): number {
    let count = 0;

    if (this.activeFilters.status?.length) count += this.activeFilters.status.length;
    if (this.activeFilters.visibility?.length) count += this.activeFilters.visibility.length;
    if (this.activeFilters.customers?.length) count += this.activeFilters.customers.length;
    if (this.activeFilters.startDate) count += 1;
    if (this.activeFilters.endDate) count += 1;

    return count;
  }

  // Mostrar SnackBar con contenido personalizado
  showSnackBar(
    message: string,
    actionText: string,
    panelClass: string | string[],
    actionCallback?: () => void
  ): void {
    this._snackBar.openFromComponent(CustomSnackBarComponent, {
      data: { message, actionText, actionCallback },
      duration: 5000,
      panelClass: Array.isArray(panelClass) ? panelClass : [panelClass],
    });
  }
  ngOnDestroy(): void {
    localStorage.removeItem('binnacleFilters');
  }
}